<template>
    <div>
        <div class="hrline-text">
            <span>Link</span>
        </div>

        <app-code>
            {{link}}
        </app-code>
    </div>
</template>

<script lang="ts">
    import {Component, Prop, Vue} from 'vue-facing-decorator';
    import AppCode from './AppCode.vue';

    @Component({
        name: 'CopyLinkPopup',
        components: {AppCode},
    })
    export default class CopyLinkPopup extends Vue
    {
        @Prop({
            type: String,
            required: true,
        }) link: string;
    }
</script>